/**
 * Client Configuration
 * 
 * Uses environment variables set during build time by deploy-frontend.js
 * Falls back to agamim defaults for backward compatibility
 */

// ============================================
// TENANT-SPECIFIC BRANDING CONFIGURATION
// ============================================
const TENANT_BRANDING = {
  agamim: {
    name: 'Agamim 360',
    logoPath: '/Logo.png',
    mainImagePath: '/mainImage.jpg',
    loginImagePath: '/loginImage.jpg',
    faviconPath: '/favicon.ico',
    cloudfront: 'https://agamim360.com',
    apiGateway: 'https://5dfnn560ai.execute-api.eu-central-1.amazonaws.com',
    sentryDsn: 'https://dfc251e63fe51a66b93830e6fcd09c37@o4509185972436992.ingest.de.sentry.io/4509185979056208',
    prismaStudio: 'https://n5ideatark.eu-central-1.awsapprunner.com/',
  },
  tidharm: {
    name: 'Tidharm 360',
    logoPath: '/Tidhar-m-Logo.jpg',
    mainImagePath: '/tidm.jpeg',
    loginImagePath: '/tidm.jpeg',
    faviconPath: '/favicon-tidharm.ico',
    cloudfront: 'https://tidharm360.com',
    apiGateway: 'https://lo6hxbnn65c5es43ias45zhw7q0yfxko.lambda-url.eu-central-1.on.aws',
    sentryDsn: '',
    prismaStudio: '',
  },
};

// Tenant info (set during build or dev)
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'agamim';
const tenantBranding = TENANT_BRANDING[TENANT_ID] || TENANT_BRANDING.agamim;

export const TENANT_NAME = process.env.REACT_APP_TENANT_NAME || tenantBranding.name;

// API Gateway (set during build, with runtime detection for local dev)
const hostname = window.location.hostname;
let API_BASE_URL;

if (hostname === 'localhost') {
  API_BASE_URL = 'http://localhost:3001';
} else if (hostname.startsWith('192.168.')) {
  API_BASE_URL = `http://${hostname}:3001`;
} else {
  // Use build-time API Gateway or tenant default
  API_BASE_URL = process.env.REACT_APP_API_GATEWAY || tenantBranding.apiGateway;
}

export { API_BASE_URL };

// Legacy export for compatibility
export const API_GETWAY = process.env.REACT_APP_API_GATEWAY || tenantBranding.apiGateway;

// CloudFront domain (set during build)
export const CLOUDFRONT_DOMAIN = process.env.REACT_APP_CLOUDFRONT_DOMAIN || tenantBranding.cloudfront;

// Sentry DSN (set during build)
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || tenantBranding.sentryDsn;

// Branding - dynamically selected based on TENANT_ID
export const WELCOME_TEXT = `Welcome to ${TENANT_NAME}`;
export const LOGO_PATH = process.env.REACT_APP_LOGO_PATH || tenantBranding.logoPath;
export const MAIN_IMAGE_PATH = process.env.REACT_APP_MAIN_IMAGE || tenantBranding.mainImagePath;
export const LOGIN_IMAGE_PATH = process.env.REACT_APP_LOGIN_IMAGE || tenantBranding.loginImagePath;
export const FAVICON_PATH = tenantBranding.faviconPath;

// Prisma Studio URL (set during build)
export const PRISMA_STUDIO_URL = process.env.REACT_APP_PRISMA_STUDIO || tenantBranding.prismaStudio;

// Log current tenant for debugging
console.log(`🏢 Frontend Tenant: ${TENANT_NAME} (${TENANT_ID})`);
